'use strict';

angular.module('paizacloudApp')
  .directive('containerMenu', function($uibModal, $rootScope, $window, Auth) {
    return {
      template: require('./containerMenu.directive.html').default,
      restrict: 'EA',
      replace: true,
      scope: {
        container: '=',
        wmController: '=',
        windowModels: '=',
      },
      link: function(scope, element, attrs) {
        scope.onClickWindows = (event) => {
          console.log('onClickWindows start');
          event.preventDefault();
          event.stopPropagation();
          console.log('onClickWindows end');
          scope.isOpen = true;
        }
        scope.isMobile = $rootScope.isMobile;
        scope.setMobile = (isMobile) => {
          scope.isMobile = isMobile;
          $rootScope.isMobile = window.isMobile = scope.isMobile;
        };
        scope.console = window.console;
        scope.isParentDisabled = (event) => {
          let target = event.target;
          let parent = target.parentNode;
          let fDisabled = parent.classList.contains('disabled');
          return fDisabled;
        };
        scope.isRunning = function(){
          return scope.container.state === 'running';
        };
      },
    };
  });
